<agpr-dialog-container
    id="mediaSubscription.backfillDialog"
    class="agpr-backfillDialog"
    heading="MediaSubscriptions.backfillDialog.heading"
    (close)="cancel()"
    [contentPadding]="false"
>
    <agpr-scroll-panel>
        <div class="agpr-backfillDialog-content">
            <p
                class="agpr-backfillDialog-message"
                [innerHTML]="'MediaSubscriptions.backfillDialog.messageHtml' | localize:{name: subscription.name}">
            </p>
            <agpr-date-range-selector
                id="monitoringResult"
                class="agpr-backfillDialog-dateRangeSelector"
                header="MediaSubscriptions.backfillDialog.dateRange"
                [options]="dateFilterOptions"
                [hideDateTypeSelection]="true"
                [(ngModel)]="selectedOption"
                [dateRange]="allowedRange"
                [useToDate]="true"
                (ngModelChange)="updateDatequery($event.value.query)"
            >
            </agpr-date-range-selector>
            <agpr-message
                *ngIf="estimate <= softLimit"
                class="agpr-backfillDialog-infoMessage"
                [severity]="messageSeverity.info"
                [bottomMargin]="estimate > softLimit"
            >
                <div
                    [agprLoading]="loading"
                    [agprInlineLoadingIndicator]="true"
                >
                    <p [innerHTML]="'MediaSubscriptions.backfillDialog.estimateHtml' | localize:{count: estimate}"></p>
                </div>
            </agpr-message>
            <agpr-message
                *ngIf="estimate > softLimit"
                class="agpr-backfillDialog-warningMessage"
                [severity]="messageSeverity.warning"
                [bottomMargin]="false"
            >
                <p [innerHTML]="'MediaSubscriptions.backfillDialog.tooManyError' | localize:{count: estimate}"></p>
            </agpr-message>
        </div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            id="mediaSubscription.backfillDialog.cancel"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="mediaSubscription.backfillDialog.ok"
            [style]="buttonTypes.primary"
            label="MediaSubscriptions.backfillDialog.ok"
            [disabled]="loading || estimate > softLimit"
            [loading]="loading"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
